export default {"src":"/_next/static/media/InPartnershipWithYoxlyLogo.e368e8eb.svg","height":21,"width":200,"blurWidth":0,"blurHeight":0};